import { render, staticRenderFns } from "./WarehouseFetchList.vue?vue&type=template&id=58e2f132&scoped=true"
import script from "./WarehouseFetchList.vue?vue&type=script&lang=js"
export * from "./WarehouseFetchList.vue?vue&type=script&lang=js"
import style0 from "./WarehouseFetchList.vue?vue&type=style&index=0&id=58e2f132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e2f132",
  null
  
)

export default component.exports